import V01 from './utils/video/01-abnormal.mp4'
import V02 from './utils/video/02-lootsma.mp4'
import V03 from './utils/video/03-mukbang.mp4'
import V04 from './utils/video/04-fala.mp4'
import V05 from './utils/video/05-wai.mp4'
import V06 from './utils/video/06-microcities.mp4'
import V07 from './utils/video/07-fosbury.mp4'
import V08 from './utils/video/08-bose.mp4'
import V09 from './utils/video/09-ghidoni.mp4'
import V10 from './utils/video/10-antonas.mp4'
import V11 from './utils/video/11-maio.mp4'
import V12 from './utils/video/12-traumnovelle.mp4'


import posterV01 from './utils/posters/01-abnormal.jpg'
import posterV02 from './utils/posters/02-lootsma.jpg'
import posterV03 from './utils/posters/03-mukbang.jpg'
import posterV04 from './utils/posters/04-fala.jpg'
import posterV05 from './utils/posters/05-wai.jpg'
import posterV06 from './utils/posters/06-microcities.jpg'
import posterV07 from './utils/posters/07-fosbury.jpg'
import posterV08 from './utils/posters/08-bose.jpg'
import posterV09 from './utils/posters/09-ghidoni.jpg'
import posterV10 from './utils/posters/10-antonas.jpg'
import posterV11 from './utils/posters/11-maio.jpg'
import posterV12 from './utils/posters/12-traumnovelle.jpg'


export default {
    projects: [
      {
        slug: 'room01',
        unit: 'Room 1 contains a kitchen sink',
        title: 'ASMR Sink',
        author: '(ab)Normal',
        video: V01,
        poster: posterV01 
      },
      {
        slug: 'room02',
        unit: 'Room 2 contains a kitchen stove',
        title: 'Play The Fire',
        author: 'Bart Lootsma',
        credits: [
          'Music: Television, "The Fire", from the album "Adventure", 1978',
          'Kitchen Stove by: goki',
          'Thanks to: Eleni Palles'
        ],
        video: V02,
        poster: posterV02
      },
      {
        slug: 'room03',
        unit: 'Room 3 contains a dining table and chair',
        title: 'Mukbang Veneziano',
        author: 'James Taylor-Foster and Anton Valek',
        video: V03,
        poster: posterV03
      },
      {
        slug: 'room04',
        unit: 'Room 4 contains a refrigerator',
        title: 'Capsule with Fuzz',
        author: 'Fala',
        credits: [
          'Model: Fala',
          'Video: Aïcha Belkhodja'
        ],
        video: V04,
        poster: posterV04
      },
      {
        slug: 'room05',
        unit: 'Room 5 contains a sleeping bed',
        title: 'Post-Colonial Victims',
        author: 'Cruz Garcia & Nathalie Frankowski / WAI Architecture Think Tank',
        video: V05,
        poster: posterV05
      },
      {
        slug: 'room06',
        unit: 'Room 6 contains a study table and chair',
        title: 'A Llullian Dream',
        author: 'Mariabruna Fabrizi + Fosco Lucarelli (Microcities / Socks-studio) and Giaime Meloni',
        video: V06,
        poster: posterV06
      },
      {
        slug: 'room07',
        unit: 'Room 7 is empty',
        title: 'Savage Love',
        author: 'Fosbury Architecture',
        credits: [
          'Written by: Fosbury Architecture',
          'Directed by: Andrea Dal Martello',
          'Based on: "The Perfect Human", Jørgen Leth, 1968'
        ],
        video: V07,
        poster: posterV07
      },
      {
        slug: 'room08',
        unit: 'Room 8 contains a living seat',
        title: 'Let them eat screens',
        author: 'Shumi Bose & Space Popular',
        credits: [
          'Music: Howard Shore, "Videodrome", from the movie "Videodrome", David Cronenberg, 1983',
          'Score original release: Varèse Sarabande',
          'Voice: Julie Khaner'
        ],
        video: V08,
        poster: posterV08
      },
      {
        slug: 'room09',
        unit: 'Room 9 contains a bath sink',
        title: 'Soap Opera',
        author: 'Matteo Ghidoni',
        credits: [
          'Collaborators: Maja Wilchelm, Noemi Benatti, Nicola Revolti',
          'Special thanks to Davide Rapp for his precious advice'
        ],
        filmography: [
          'Excerpts from:',
          '\"The General\", Buster Keaton, Clyde Bruckman, 1926',
          '"Macbeth", Orson Welles, 1948',
          '"The Aviator", Martin Scorsese, 2004',
          '"The Dark Knight", Christopher Nolan, 2008',
          '"Macbeth", Rupert Goold, 2010',
          '"Twin Peaks: Fire Walk with Me", David Lynch, 1992',
          '"Lava Soap Commercial"',
          '"The Incredibles", Brad Bird, 2004',
          '"Twin Peaks: Fire Walk with Me", David Lynch, 1992',
          '"Planet of the Apes", Tim Burton, 2001',
          '"American Housewife", "The Playdate" [S01E10]',
          '"Stranger Things", "Chapter Eight - The Upside Down" [S01E08]',
          '"Soapy Says: Wash your Hands Cowboy"',
          '"No Country for Old Men", Joel Coen, Ethan Cohen, 2007',
          '"Only God Forgives", Nicolas Winding Refn, 2013',
          '"Suspiria", Dario Argento, 1977',
          '"Pulp Fiction", Quentin Tarantino, 1994',
          '"Macbeth", Rupert Goold, 2010',
          '"Solvol Commercial"',
          '"Snow White and the Seven Dwarfs", Walt Disney, 1937',
          '"A Day at the Races", Sam Wood, 1937',
          '"Whatever Works", Woody Allen, 2009',
          '"Suspiria", Dario Argento, 1977',
          '"Repulsion", Roman Polański, 1965',
          '"Reservoir Dogs", Quentin Tarantino, 1992',
          '"American Psycho", Mary Harron, 2000',
          '"The Passion of the Christ", Mel Gibson, 2004',
          '"Une Femme Marieé", Jean-Luc Godard, 1964',
          '"The Secret Life of My Secretary", Lee Kwang-young, 2019',
          '"Camay Soap commercial"',
          '"The Princess Diaries", Garry Marshall, 2001',
          '"So I Married an Axe Murderer", Thomas Schlamme, 1993',
          '"Parks and Recreation", "Ron and Tammys" [S04E02]',
          '"Pirates of the Caribbean At World\'s End", Gore Verbinski, 2007',
          '"The Golden Girls", "The Engagement" [S01E01]',
          '"Welcome to the Dollhouse", Todd Solondz, 1995',
          '"Macbeth", Roman Polański, 1971',
          '"Macbeth", Justin Kurzel, 2015',
          '"New Girl", "Thanksgiving" [S01E06]',
          '"Twin Peaks: Fire Walk with Me", David Lynch, 1992',
          '"Along Came Polly", John Hamburg, 2004',
          '"Black Dynamite", Scott Sanders, 2009',
          '"30 Rock", "Lee Marvin vs. Derek Jeter" [S04E17]',
          '"Friends", "The One with the Ultimate Fighting Champion" [S03E24]',
          '"Pirates of the Caribbean At World\'s End", Gore Verbinski, 2007',
          '"Revenge", "Duress" [S01E11]',
          '"Divorce", "Detente" [S01E10]',
          '"Twin Peaks", "The Man Behind the Glass" [S02E03]',
          '"Macbeth", Roman Polański, 1971',
          '"Raising Arizona", Ethan Coen, Joel Coen, 1987',
          '"Star Trek", "Dagger of the Mind" [S01E09]',
          '"The Parent Trap", David Swift, 1961',
          '"The Tingler", William Castle, 1959',
          '"Devious Maid", "Walking the Dog" [S01E06]',
          '"Dodgeball: A True Underdog Story", Rawson Marshall Thurber, 2004',
          '"Cat on a Hot Tin Roof", Richard Brooks, 1958',
          '"Empire", "Out, Damned Spot" [S01E06]',
          '"It\'s Always Sunny in Philadelphia", "The Gang Gets Invincible" [S03E02]',
          '"Absentia", "Cover" [S02E06]',
          '"Sesame Street: Time to Wash Your Hands"',
          '"Jesus Christ Superstar", Norman Jewison, 1973',
          '"Jackie Brown", Quentin Tarantino, 1997',
          '"Pulp Fiction", Quentin Tarantino, 1994',
          '"Don King: Only in America", John Herzfeld, 1997',
          '"South Park", season 13, 2009',
          '"Bean", Mel Smith, 1997',
          '"Futurama", "Cold Warriors" [S06E24]',
          '"The Mick", "The Fire" [S01E05]',
          '"American Dad", "A Boy Named Michael" [S10E02]',
          '"Friends", "The One With Rachel\'s Book" [S07E02]',
          '"The Office", season 02, 2005',
          '"Horrible Bosses 2", Sean Anders, 2014',
          '"Macbeth", Justin Kurzel, 2015',
          '"Sex Education", Laurie Nunn, 2019',
          '"BoJack Horseman", "The Shot" [S02E09]',
          '"The Parent Trap", David Swift, 1961',
          '"Lethal Weapon 3", Richard Donner, 1992',
          '"Animal Kingdom", David Michôd, 2010',
          '"Lethal Weapon 3", Richard Donner, 1992',
          '"Friends with Benefits", Will Gluck, 2011',
          '"Fun with Dick and Jane", Dean Parisot, 2005',
          '"Grey\'s Anatomy", "Falling Slowly" [S13E04]',
          '"The Sopranos", "Mr. Ruggerio\'s Neighborhood" [S03E01]',
          '"Barb Wire", David Hogan, 1996',
          '"Veep", "Fishing" [S03E05]',
          '"Sesame Street"'
        ],
        video: V09,
        poster: posterV09
      },
      {
        slug: 'room10',
        unit: 'Room 10 contains a bathtub',
        title: 'Bathtub for John Hejduk',
        author: 'Aristide Antonas',
        credits: [
          'Image and video editing: Katerina Koutsogianni for Antonas Office'
        ],
        video: V10,
        poster: posterV10
      },
      {
        slug: 'room11',
        unit: 'Room 11 contains a shower',
        title: '#shower',
        author: 'MAIO',
        video: V11,
        poster: posterV11
      },
      {
        slug: 'room12',
        unit: 'Room 12 contains a toilet',
        title: 'The chosen Twelve',
        author: 'Traumnovelle',
        video: V12,
        poster: posterV12
      }
    ],
    pages: {
      about: {
        slug: 'about',
        descriptions: [
          {
            main_text: [
              'In the summer of 2020, a group of twelve architects and scholars spent one week of residency locked inside an abandoned house built on a small island in the Venetian lagoon. One per room. Each room was equipped with only one piece of furniture, which they couldn\'t choose.',
              'The house was an almost exact replica of what – at least until recently – was believed to be an unrealised project by John Hejduk: the House for the Inhabitant who Refused to Participate.',
              'The curators of the Unfolding Pavilion came to know about the house by pure chance, and decided to organise their third pavilion inside of its spaces. An agreement was made with the owners of the island, who were about to demolish the house in order to build a luxury glamping facility in its stead: the house could be temporarily occupied for artistic purposes, but no images of the event were to be published before the demolition took place. The house was demolished in early December.',
              'This website is the first documentation of the installations made by the twelve contributors during their one-week residency.'
            ]
          }
        ]
      },
      intro: {
        slug: 'welcome',
        message: [
          'For the full experience of the exhibition please grant access to the webcam and switch to fullscreen mode. We will not record nor save anything.'
        ],
        mobile: [
          'For the full experience of the exhibition please grant access to the webcam. We will not record nor save anything.'
        ]
      }
    }
  }